export default __webpack_public_path__ + "static/media/BLR5.38139ee3.jpg";